
import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getIntegrationItemGroups = (
    token: string,
    backend: string,
    id: any
) => {
    return fetch(
        `${getApiUrl(backend)}integrationItemGroups/${id}`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json, text/plain, */*'
            },
        }
    );
};

export default getIntegrationItemGroups;